import React, { FunctionComponent, useState, useEffect } from "react";
import { Box } from "@mui/material";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiPopupInput from "src/components/core-components/mui/inputs/ByzMuiPopupInput";
import { useAppSelector } from "src/app/hooks";
import { useTranslate } from "src/locales";

export interface PregnantCardData {
  operationDate: Date | null;
  operator: string;
  pregnancyStatus: string;
}

interface PregnantCardListProps {
  onDataChange?: (data: PregnantCardData) => void;
  initialData?: PregnantCardData | null;
  pregnancyStatusOptions?: Array<{ name: string; value: string }>;
}

const PregnantCardList: FunctionComponent<PregnantCardListProps> = ({
  onDataChange,
  initialData,
  pregnancyStatusOptions = [],
}) => {
  const { t } = useTranslate();
  const { user } = useAppSelector((state) => (state as any).auth);

  const [operationDate, setOperationDate] = useState<Date | null>(
    initialData?.operationDate || new Date()
  );
  const [operator, setOperator] = useState<string>(
    initialData?.operator || ""
  );
  const [pregnancyStatus, setPregnancyStatus] = useState<string>(
    initialData?.pregnancyStatus || ""
  );

  useEffect(() => {
    if (initialData) {
      // initialData'dan gelen tarihi kullan, yoksa mevcut tarihi koru
      if (initialData.operationDate) {
        setOperationDate(initialData.operationDate);
      }
      setOperator(initialData.operator || "");
      setPregnancyStatus(initialData.pregnancyStatus || "");
    } else {
      // Veri yoksa sadece tarihi set et, kullanıcı adını set etme
      if (!operationDate) {
        setOperationDate(new Date());
      }
      setOperator("");
      setPregnancyStatus("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialData?.operationDate, initialData?.operator, initialData?.pregnancyStatus]);

  useEffect(() => {
    if (onDataChange) {
      onDataChange({
        operationDate,
        operator,
        pregnancyStatus,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operationDate, operator, pregnancyStatus]);

  return (
    <Box sx={{ width: "100%", position: "relative", display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "22px", textAlign: "left", fontSize: "14px", color: "#111827", fontFamily: "Urbanist" }}>
      <Box sx={{ alignSelf: "stretch", display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "12px" }}>

        <Box sx={{ alignSelf: "stretch", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <Box sx={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" }}>
            <Box sx={{ width: "200px", position: "relative", lineHeight: "150%", fontWeight: 600 }}>{t("pregnancy.operation-date")} :</Box>
            <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <ByzMuiDateTimePicker
                value={operationDate}
                onChange={(val) => setOperationDate(val as Date | null)}
                width="180px"
                disabled
              />
            </Box>
          </Box>
        </Box>

        <Box sx={{ alignSelf: "stretch", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <Box sx={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" }}>
            <Box sx={{ width: "200px", position: "relative", lineHeight: "150%", fontWeight: 600 }}>{t("pregnancy.operation-user")} :</Box>
            <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <ByzMuiTextField
                label={t("pregnancy.operation-user")}
                value={operator}
                onChange={(e) => setOperator(e.target.value)}
                sx={{ width: "180px" }}
                cantChange
                noPlaceholder
              />
            </Box>
          </Box>
        </Box>

        <Box sx={{ alignSelf: "stretch", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <Box sx={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" }}>
            <Box sx={{ width: "200px", position: "relative", lineHeight: "150%", fontWeight: 600 }}>{t("pregnancy.pregnancy-status")} :</Box>
            <ByzMuiPopupInput
              label={t("pregnancy.pregnancy-status")}
              value={pregnancyStatus}
              onChange={(val: string) => setPregnancyStatus(val === "" ? "" : val)}
              dialogTitle={t("pregnancy.pregnancy-status")}
              options={pregnancyStatusOptions.map((option) => ({
                value: option.value,
                label: option.name,
              }))}
              sx={{ width: "180px" }}
            />
          </Box>
        </Box>

      </Box>
    </Box>
  );
};

export default PregnantCardList;
